import React from "react";
import Introduction from "../../components/Introduction";
import ScrollAnimation from "react-animate-on-scroll";
import About from "../../components/About";
import Experience from "../../components/Experience";
import LatestWork from "../../components/LatestWork";
import Skills from "../../components/Skills";
import Testimonials from "../../components/Testimonials";

const HomePage = () => {
  return (
    <div className="HomePage">
      <Introduction />
      <About />
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
        <Experience />
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
        <LatestWork />
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
        <Skills />
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
        <Testimonials />
      </ScrollAnimation>
    </div>
  );
};

export default HomePage;
